import PromoCodeActions from '../../../actions/PromoCodeActions';
import CustomNotify from "../../Notify";

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        PromoCodeActions.getListLinks(params, (response) => {
            success && success(response.items[0]);
        }, {});
    },

    deletePromoCode(id, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            id: id
        };

        PromoCodeActions.deletePromoCode(params).then(data => {
            CustomNotify(notyNames.delete);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};
